import { combineReducers } from 'redux';
import { api } from '../api-generated';
import selectedContract from './SelectedContract/index';
import { SelectedContractAction } from '../actions/SelectedContract';

const rootReducer = combineReducers({
  api: api.reducer,
  selectedContract,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export type RootActions = SelectedContractAction;
